import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class AdvyzonIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getAdvyzonIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.ADVYZON_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getAdvyzonAccountSearchResults(searchTerms, page) {
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ADVYZON_SEARCH)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importAdvyzonAccountHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.ADVYZON_IMPORT_ACCOUNT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
AdvyzonIntegrationService.ɵfac = function AdvyzonIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AdvyzonIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AdvyzonIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AdvyzonIntegrationService, factory: AdvyzonIntegrationService.ɵfac, providedIn: 'root' });
